// Authentication API for OTP flow
import CONFIG from '@alice/shared/config';

const API_BASE = CONFIG.API_BASE_URL;

export const requestOTP = async (emailAddress) => {
  const response = await fetch(`${API_BASE}/auth/request-otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Important for cookies
    body: JSON.stringify({ emailAddress }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to request OTP');
  }

  return data;
};

export const verifyOTP = async (emailAddress, code) => {
  const response = await fetch(`${API_BASE}/auth/verify-otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Important for cookies
    body: JSON.stringify({ emailAddress, code }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Invalid verification code');
  }

  return data;
};

export const getCurrentUser = async () => {
  const response = await fetch(`${API_BASE}/auth/me`, {
    credentials: 'include', // Important for cookies
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  return data; // Server returns user object directly, not wrapped
};

export const logout = async () => {
  const response = await fetch(`${API_BASE}/auth/logout`, {
    method: 'POST',
    credentials: 'include', // Important for cookies
  });

  return response.ok;
};
